import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  onClick: () => void;
}

const CancelButton: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
  ...otherProps
}) => {
  const { t } = useTranslation();

  return (
    <CancelButtonComponent onClick={onClick} {...otherProps}>
      {t('Cancel')}
    </CancelButtonComponent>
  );
};

const CancelButtonComponent = styled.button`
  background: none;
  cursor: pointer;
  border: none;
  margin-top: 0.8rem;
  color: ${({ theme }) => theme.status.error};
  text-decoration: underline;
  font-size: 1.6rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export default CancelButton;
